import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
} from "react-native";

// import { BarChart } from "react-native-chart-kit";

const Calendercustomchart = () => {
  const initialData = [
    {
      label: "1",
      segments: [
        { value: 30, color: "#03C3FF" },
        { value: 20, color: "#FEB019" },
        { value: 10, color: "#FF4560" },
      ],
      value: 500,
    },
    {
      label: "2",
      segments: [
        { value: 15, color: "#FF4560" },
        { value: 25, color: "#00E396" },
      ],
      value: 600,
    },
    {
      label: "3",
      segments: [
        { value: 30, color: "#00E396" },
        { value: 15, color: "#FF4560" },
        { value: 5, color: "#FEB019" },
      ],
      value: 100,
    },
    {
      label: "4",
      segments: [
        { value: 20, color: "#00E396" },
        { value: 40, color: "#FF4560" },
      ],
      value: 900,
    },
    {
      label: "5",
      segments: [
        { value: 30, color: "#00E396" },
        { value: 40, color: "#FEB019" },
        { value: 20, color: "#FF4560" },
      ],
      value: 700,
    },
    {
      label: "6",
      segments: [
        { value: 10, color: "#FEB019" },
        { value: 20, color: "#00E396" },
        { value: 10, color: "#FEB019" },
      ],
      value: 800,
    },
    {
      label: "7",
      segments: [
        { value: 15, color: "#FF4560" },
        { value: 25, color: "#FEB019" },
      ],
      value: 600,
    },
  ];

  const [startIndex, setStartIndex] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date());

  // Get the current set of ten data items based on the startIndex
  const data = initialData.slice(startIndex, startIndex + 10);

  const maxValue = Math.max(...initialData.map((item) => item.value));

  const handleLeftClick = () => {
    const newStartIndex =
      (startIndex - 10 + initialData.length) % initialData.length;
    setStartIndex(newStartIndex);
  };

  const handleRightClick = () => {
    const newStartIndex = (startIndex + 10) % initialData.length;
    setStartIndex(newStartIndex);
  };

  const handlePreviousMonth = () => {
    setCurrentDate((prevDate) => {
      const prevMonth = new Date(
        prevDate.getFullYear(),
        prevDate.getMonth() - 1
      );
      return prevMonth;
    });
  };

  const handleNextMonth = () => {
    setCurrentDate((prevDate) => {
      const nextMonth = new Date(
        prevDate.getFullYear(),
        prevDate.getMonth() + 1
      );
      return nextMonth;
    });
  };

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const renderCalendar = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDay = getFirstDayOfMonth(year, month);

    const calendar = [];

    // Fill in the days of the previous month
    for (let i = 0; i < firstDay; i++) {
      calendar.push(<Text key={`prev-${i}`} style={styles.emptyCell} />);
    }

    // Fill in the days of the current month
    for (let day = 1; day <= daysInMonth; day++) {
      calendar.push(
        <TouchableOpacity
          key={`day-${day}`}
          style={styles.dayCell}
          onPress={() => handleDateSelection(day)}
        >
          <Text style={styles.dayText}>{day}</Text>
        </TouchableOpacity>
      );
    }

    // Fill in the days of the next month to complete the calendar grid
    for (let i = 1; i <= 42 - daysInMonth - firstDay; i++) {
      calendar.push(
        <View key={`next-${i}`} style={styles.emptyCell}>
          <Text style={styles.dayText}>{i}</Text>
        </View>
      );
    }

    return calendar;
  };

  const handleDateSelection = (day) => {
    console.log("Selected day:", day);
  };

  const handlePreviousMonth1 = () => {
    setCurrentDate((prevDate) => {
      const prevMonth = new Date(
        prevDate.getFullYear(),
        prevDate.getMonth() - 1
      );
      return prevMonth;
    });
  };

  const handleNextMonth1 = () => {
    setCurrentDate((prevDate) => {
      const nextMonth = new Date(
        prevDate.getFullYear(),
        prevDate.getMonth() + 1
      );
      return nextMonth;
    });
  };
  return (
    <TouchableOpacity
      onPress={handleNextMonth1}
      style={{
        left: 5,
      }}
    >
      <Text style={styles.month}>
        {currentDate.toLocaleString("default", {
          month: "long",
          // year: "numeric",
        })}
      </Text>
    </TouchableOpacity>
  );
};

export default Calendercustomchart;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",

    height: 200,

    alignItems: "center",
  },
  barChart: {
    //marginVertical: 8,
    // borderRadius: 8,
    //backgroundColor:'yellow'
    marginRight: 30,
  },
  label: {
    fontSize: 12,
    marginTop: 4,
  },
  daysText: {
    fontSize: 10,
  },
  monthText: {
    fontSize: 10,
    marginTop: 2,
    color: "#555",
  },
  dayText: {
    fontSize: 10,
    marginTop: 2,
    color: "#555",
  },

  barContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  bar: {
    width: 25,
    backgroundColor: "blue",
    marginBottom: 4,
  },
  barSegment: {
    flex: 1,
    backgroundColor: "lightblue",
  },
  label: {
    fontSize: 12,
    marginTop: 4,
  },
  buttonContainer: {
    flexDirection: "row",
    backgroundColor: "green",
  },
  arrow: {
    color: "#9C4900",
  },
  buttonText: {
    fontSize: 16,
    color: "black",
  },
  month: { color: "#9C4900", marginRight: 3, marginLeft: 3 },
});
